<template>
  <BaseModalSmall
      @close="close"
      v-bind:isValidated="true"
      @confirm="confirm(true)"
      @cancel="confirm(false)"
      :noSlide="true"
      :split-buttons="true"
      confirm-text="Continue"
      decline-text="Cancel application"
  >
    <template v-slot:header>Long-Term Resident Information</template>
    <template v-slot:body>
      <div>
        <p>
          You have indicated that you may not be a Long-Term Resident (LTR) in the UK. This status can significantly
          affect your Inheritance Tax (IHT) liability. Under UK tax rules. Because international residency and tax
          rules are complex, we strongly recommend seeking advice from a specialist. You may continue writing your
          Will now, provided you understand that your residency status could impact your ultimate IHT liability.

<!--          You have advised us that you may not be domiciled in {{ personalDetails.country }}. This could affect the-->
<!--          laws governing your will and its distributions. If you do not have any assets outside of-->
<!--          {{ personalDetails.country }} and you intend to remain in {{ personalDetails.country }} for the-->
<!--          remainder of your life it may be possible that you have adopted a 'domicile of choice' and can be-->
<!--          treated as domiciled in {{ personalDetails.country }}, although this can be complicated-->
<!--          and specialist advice should be obtained. If you wish to continue to complete your will you do so-->
<!--          with the understanding it may not completely reflect your circumstances if you are not domiciled-->
<!--          in {{ personalDetails.country }} when you pass away.-->
        </p>
      </div>
    </template>
  </BaseModalSmall>
</template>

<script>
import BaseModalSmall from '@/common/ui/BaseModalSmall'

export default {
  name: 'DomicileModal',
  components: {
    BaseModalSmall
  },
  computed: {
    personalDetails() {
      return this.$store.getters.personalDetails
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm(value) {
      this.$emit('confirm', value)
      this.close()
    }
  }
}
</script>
